import postone from "../../assets/images/post-1.png";
import posttwo from "../../assets/images/post-2.png";
import postthree from "../../assets/images/post-3.png";
import groupone from "../../assets/images/group-1.png";
import grouptwo from "../../assets/images/group-2.png";
import groupthree from "../../assets/images/group-3.png";
import groupfour from "../../assets/images/group-4.png";
import groupfive from "../../assets/images/group-5.png";
import profileimg from "../../assets/profile.png";
import userimg from "../../assets/user.png";
import profilebanner from "../../assets/images/Profile-banner.png";
import axios from "axios";


const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
export const fetchGroups = async () => {
  const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  if (!token) return console.error("No token found, please log in.");

  try {
    const response = await fetch(`${API_BASE_URL}/group/get-groups`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: `${token}`,
      },
      body: JSON.stringify({
        filters: {
          myAcceptedGroup: true,
        },
        page: 1,
        limit: 10,
      }),
    });

    const data = await response.json();

    if (data.success) {
      // Extract the groups array from the response
      const groups = data.result.groups.map((group) => ({
        id: group.id,
        name: group.group_name,
        description: group.description,
        img: group.group_image,
        cover: group.group_cover,
        followers: group.acceptedMembersCount || 0,
        admins: group.adminCounts || 0,
        createdAt: group.created_at,
        members: group.members || [],
      }));

      return groups;
    } else {
      console.error("Failed to fetch groups:", data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching groups:", error);
    return [];
  }
};
const friendRequests = [
    {
      id: 1,
      name: "Team Unicorns...",
      followers: 200,
      img: groupone,
      followerImages: [postone, posttwo, postthree],
    },
    {
      id: 2,
      name: "Code Masters",
      followers: 150,
      img: grouptwo,
      followerImages: [postone, posttwo, postthree],
    },
    {
      id: 3,
      name: "Gaming Legends",
      followers: 300,
      img: groupthree,
      followerImages: [postone, posttwo, postthree],
    },
    {
      id: 4,
      name: "Nithish Kumar",
      followers: 4,
      img: groupfour,
      followerImages: [postone, posttwo, postthree],
    },
];

const groupData = [
    {
      id: 1,
      groupName: "Team Unicorns...",
      profileimg: groupone,
      coverimg: profilebanner,
      intro: "A dynamic team of creative minds working together.",
      followers: 300,
      createdOn: "21 January 2025",
      admins: 3,
      members: [
        { id: 101, name: "Alice Johnson", username: "@alicej", role: "Admin" },
        { id: 102, name: "John Doe", username: "@johnd", role: "Member" },
        { id: 103, name: "Sarah Smith", username: "@sarahs", role: "Member" }
      ],
    },
    {
      id: 2,
      groupName: "Code Masters",
      profileimg: grouptwo,
      coverimg: profilebanner,
      intro: "An elite marketing team driving growth through strategies.",
      followers: 150,
      createdOn: "15 March 2024",
      admins: 2,
      members: [
        { id: 201, name: "Mark Lee", username: "@marklee", role: "Admin" },
        { id: 202, name: "Emma Watson", username: "@emmaw", role: "Member" },
      ],
    },
    {
      id: 3,
      groupName: "Gaming Legends",
      profileimg: groupthree,
      coverimg: profilebanner,
      intro: "An elite marketing team driving growth through strategies.",
      followers: 150,
      createdOn: "15 March 2024",
      admins: 2,
      members: [
        { id: 201, name: "Mark Lee", username: "@marklee", role: "Admin" },
        { id: 202, name: "Emma Watson", username: "@emmaw", role: "Member" },
      ],
    },
    {
      id: 4,
      groupName: "Nithish Kumar",
      profileimg: groupfour,
      coverimg: profilebanner,
      intro: "An elite marketing team driving growth through strategies.",
      followers: 150,
      createdOn: "15 March 2024",
      admins: 2,
      members: [
        { id: 201, name: "Mark Lee", username: "@marklee", role: "Admin" },
        { id: 202, name: "Emma Watson", username: "@emmaw", role: "Member" },
      ],
    },
];
// Example usage
export const loadFriendRequests = async () => {
  const friendRequests = await fetchGroups();
  return friendRequests;
};
export { friendRequests, groupData };
